import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mono.svg'


const _withScopeId = n => (_pushScopeId("data-v-708a5625"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero is-fullheight is-tp-login animated-gradient" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "columns" }
const _hoisted_5 = { class: "column is-12 is-flex is-justify-content-center" }
const _hoisted_6 = { class: "columns is-multiline pb-2" }
const _hoisted_7 = { class: "column is-12" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "data-test": "app-logo",
  alt: "Teleperformance logo"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "column is-12" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title is-6 mt-6 mb-3 has-text-danger" }, "We have encountered a problem.", -1))
const _hoisted_12 = { class: "is-size-6 mb-2 error-summary" }
const _hoisted_13 = { class: "is-size-7 mt-6 has-text-grey" }
const _hoisted_14 = {
  key: 0,
  class: "is-size-7 has-text-grey"
}
const _hoisted_15 = { class: "is-size-7 has-text-grey" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", {
              id: "frmLogin",
              name: "frmLogin",
              onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
              class: _normalizeClass(["box p-6", { 'is-loading': _ctx.loadingLogin }]),
              "data-test": "frm-login"
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("figure", {
                    class: "image",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDoIt && _ctx.toggleDoIt(...args)))
                  }, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.message), 1),
                  _createElementVNode("p", _hoisted_13, "Error Code " + _toDisplayString(_ctx.$route.params.code), 1),
                  (_ctx.tpId)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.tpId), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.datetime), 1)
                ])
              ])
            ], 34)
          ])
        ])
      ])
    ])
  ]))
}